module.exports = __webpack_public_path__ + "img/chatbots_link.39b88b3d.png";